import { useNavigate } from "react-router-dom";
import "./BreadCrumbsFile.css";

const Breadcrumbs = ({ crumbs }) => {
  const navigate = useNavigate();

  return (
    <div className="breadcrumbs">
      {crumbs.map((crumb, index) => (
        <span key={index}>
          {crumb.path ? (
            <span
              className="breadcrumb-link"
              onClick={() =>
                navigate(crumb.path, {
                  state: crumb.state || {}, // pass state if any
                })
              }
            >
              {crumb.label}
            </span>
          ) : (
            <span className="breadcrumb-current">{crumb.label}</span>
          )}
          {index < crumbs.length - 1 && <span> / </span>}
        </span>
      ))}
    </div>
  );
};

export default Breadcrumbs;
